import { isIntendedOnNewTab } from "@circle-react/helpers/browserHelpers";
import { Link } from "@tanstack/react-router";
import { noop } from "lodash";

import { usePreviousLocationState } from "@/react/hooks/usePreviousLocationState";

interface ItemWrapperProps {
  children: React.ReactNode;
  onClose: () => void;
  uuid: string;
}

export const ItemWrapper = ({
  children,
  onClose = noop,
  uuid,
}: ItemWrapperProps) => {
  const previousLocationState = usePreviousLocationState();

  return (
    <div className="mx-2 border-b border-secondary-dark last:border-none">
      <Link
        className="-mx-2 flex cursor-pointer items-start justify-between rounded-md px-4 py-3 transition-colors duration-200 ease-in-out hover:bg-tertiary focus-visible:bg-tertiary"
        onClick={e => {
          if (!isIntendedOnNewTab(e)) {
            onClose();
          }
        }}
        to="/messages/$uuid"
        params={{ uuid }}
        state={previousLocationState}
        data-testid="chat-room-dm-list"
      >
        {children}
      </Link>
    </div>
  );
};
